import Vue from "vue"
import { BootstrapVue } from "bootstrap-vue"
import Icon from "vue-awesome/components/Icon"
import moment from "moment"
import momentDurationFormat from "moment-duration-format"
import DataTable from "@andresouzaabreu/vue-data-table"
import Datepicker from "vuejs-datepicker"
import { TheMask } from "vue-the-mask";
import Vue2Filters from "vue2-filters"
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap"
import store from "./store/index"
import App from "./App.vue"

import "bootstrap/dist/css/bootstrap.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import "vue-awesome/icons"
import "bootstrap/dist/css/bootstrap.min.css"
import "@andresouzaabreu/vue-data-table/dist/DataTable.css"
import "@/assets/css/jquery-ui.css"
import "@/assets/css/header.css"
import "@/assets/css/main.css"
import "@/assets/css/lib.css"
import "@/assets/css/style.css"

Vue.config.productionTip = true

Vue.use(BootstrapVue)
Vue.use(Vue2Filters)

Vue.component("icon", Icon)
Vue.component("data-table", DataTable)
Vue.component("datepicker", Datepicker)
Vue.component("the-mask", TheMask)
Vue.component("vue-typeahead-bootstrap", VueTypeaheadBootstrap)

Vue.prototype.moment = moment
Vue.prototype.momentDurationFormat = momentDurationFormat

new Vue({
    store,
    render: h => h(App)
}).$mount("#app")

export const bus = new Vue();